import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=27f6363c&scoped=true&lang=pug&"
import script from "./StudentInfo.vue?vue&type=script&lang=ts&"
export * from "./StudentInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&id=27f6363c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6363c",
  null
  
)

export default component.exports